import { createAsyncThunk } from "@reduxjs/toolkit";
import { metaDetailsService } from "service/metaDetailsService";
import { NOTIFY } from "constants/notifyType";
import Notify from "helpers/Notify";

export const getMetaDetailsByPathname = createAsyncThunk(
  "metaDetails/getMetaDetailsByPathname",
  async (pathname, { rejectWithValue, fulfillWithValue }) => {
    try {
      const response =
        await metaDetailsService.getMetaDetailsByPathname(pathname);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return fulfillWithValue(null);
      }
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const createMetaDetails = createAsyncThunk(
  "metaDetails/createMetaDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await metaDetailsService.createMetaDetails(data);
      Notify(NOTIFY.type.success, NOTIFY.message.add);
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const updateMetaDetails = createAsyncThunk(
  "metaDetails/updateMetaDetails",
  async ({ pathname, data }, { rejectWithValue }) => {
    try {
      const response = await metaDetailsService.updateMetaDetails(
        pathname,
        data,
      );
      Notify(NOTIFY.type.success, NOTIFY.message.update);
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
